export default {"src":"/frontend-static/_next/static/media/star-badge.4a4f0077.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};